import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export {Observable};


@Injectable({
  providedIn: 'root'
})
export class RemoteCallCommonService {
  private _url_base_default = environment.url_base;
  private _url_base = this._url_base_default;

  // ---------------------------------------------------------------------------
  get url_base(): string {
    return this._url_base;
  }
  set url_base(new_url: string) {
    this._url_base = new_url
  }

  // ---------------------------------------------------------------------------
  get url_base_default(): string {
    return this._url_base_default;
  }
  // ===========================================================================
  // ---------------------------------------------------------------------------
  constructor(
      private http: HttpClient,
      // private _modal_window: MatDialog,
  ) { }

  public read(endpoint: string, data: any): Observable<any> {
    console.warn('read is obsolete. Please use readPost or readGet.');
    return this.readPost(endpoint, data);
  }

  // ===========================================================================
  // ---------------------------------------------------------------------------
  // Send post data as form data
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSON with data to send
  public readGet(endpoint: string, data: any): Observable<any> {

//    return new Observable( (observer:Observer<any>) => {
//        this.sendGet(endpoint, data).subscribe(
//            (read_data: any) => {
//                observer.next(read_data)
//            },
//            (error: HttpErrorResponse) => {
//                this._showMessage(error.message, 'error')
//                observer.error(error)
//            },
//            () => {
//                observer.complete()
//            }
//        );
//    });
      return this.sendGet(endpoint, data);
  }

  // ---------------------------------------------------------------------------
  // Send post data as form data
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSON with data to send
  public readPost(endpoint: string, data: any): Observable<any> {

//    return new Observable( (observer:Observer<any>) => {
//        this.sendPost(endpoint, data).subscribe(
//            (read_data: any) => {
//                observer.next(read_data)
//            },
//            (error: HttpErrorResponse) => {
//                this._showMessage(error.message, 'error')
//                observer.error(error)
//            },
//            () => {
//                observer.complete()
//            }
//        );
//    });
      return this.sendPost(endpoint, data);
  }

  // ---------------------------------------------------------------------------
  // Send post data as JSON
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSON with data to send
  //
  //  TODO: Test if it work
  public readPostJSON(endpoint: string, data: any): Observable<any> {

//    return new Observable( (observer:Observer<any>) => {
//        this.sendPostJSON(endpoint, data).subscribe(
//            (read_data: any) => {
//                observer.next(read_data)
//            },
//            (error: HttpErrorResponse) => {
//                this._showMessage(error.message, 'error')
//                observer.error(error)
//            },
//            () => {
//                observer.complete()
//            }
//        );
//    });
      return this.sendPostJSON(endpoint, data);
  }

  // ---------------------------------------------------------------------------
  // Send post data as form data
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSOn with data to be written
  public write(endpoint: string, data: any): Observable<any> {
//      return new Observable( (observer:Observer<any>) => {
//          console.log('remote::write => ', data)
//          this.sendPost(endpoint, data).subscribe(
//              (read_data: any) => {
//                  observer.next(read_data)
//              },
//              (error: HttpErrorResponse) => {
//                  this._showMessage(error.message, 'error')
//                  observer.error(error)
//              },
//              () => {
//                  observer.complete()
//              }
//          );
//      });
      return this.sendPost(endpoint, data);
  }

  // ---------------------------------------------------------------------------
  // Send post data as JSON
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSOn with data to be written
  public writeJSON(endpoint: string, data: any): Observable<any> {
//      return new Observable( (observer:Observer<any>) => {
//          this.sendPostJSON(endpoint, data).subscribe(
//              (read_data: any) => {
//                  observer.next(read_data)
//              },
//              (error: HttpErrorResponse) => {
//                  this._showMessage(error.message, 'error')
//                  observer.error(error)
//              },
//              () => {
//                  observer.complete()
//              }
//          );
//      });
      return this.sendPostJSON(endpoint, data);
  }


  // ---------------------------------------------------------------------------
  // Send get data as form data
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSON with data to send
  protected sendGet(endpoint: string, data: any): Observable<any> {
    let url = this._url_base + '/' + endpoint;

    let get_params  = new HttpParams();
    if ( data ) {
        for (var field in data) {
          if (typeof data[field] === 'object') {
            data[field] = JSON.stringify(data[field]);
          }
          get_params.set(field, data[field]);
        }
    }
    url += (data?'?'+get_params.toString():'');
    const sub = this.http.get(url);
    return sub;

  }

  // ---------------------------------------------------------------------------
  // Send post data as form data
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSOn with data to send
  protected sendPost(endpoint: string, data: any): Observable<any> {
    const url = this._url_base + '/' + endpoint;

    let formData: FormData | null = null;
    if ( data ) {
        formData = new FormData();
        for (var field in data) {
            formData.append(field, data[field]);
        }
    }

    const sub = this.http.post(url, formData);
    return sub;

  }

  // ---------------------------------------------------------------------------
  // Send post data as form data
  //    @param endpoint string => endpoint we want to call
  //    @param data: Objet JSOn with data to send
  protected sendPostJSON(endpoint: string, data: any): Observable<any> {
    const headers = { 'content-type': 'application/json'};
    const url = this._url_base + '/' + endpoint;
    const body = JSON.stringify(data);

    return this.http.post(url, body,{'headers':headers});

  }

}
